//libraries
import Vue from 'vue'
import axios from 'axios'

import { ability } from '@/helpers/abilities'

let resource = 'organization'
let resource_name = 'organización'
let resource_name_plural = 'organizaciones'

let state = {
  organization: {},
  plugins: [],
  accounts: []
}

state[resource + 's'] = []

let getCurrentUser = () => {
  let user = Vue.prototype.$getCookie('user')
  if (user) {
    return user
  } else {
    Vue.prototype.$router.push({name: 'logout'}).catch(() => {})
    return null
  }
}

//functions receive state
let getters = {
  parsedPlugins (state, getters, rootState, rootGetters) {
    let limitPlugins = []
    // let account = rootState.account.account
    // let isEcommerce = (new RegExp('^konverza-ecommerce', 'i')).test(account.type)
    // let user = getCurrentUser()
    // let isKonverza = (new RegExp('^konverza-', 'i')).test(getCurrentUser().Role.type)
    // let isPartner = (new RegExp('^konverza-partner', 'i')).test(getCurrentUser().Role.type)

    // if (isKonverza) {
    //   if ( (isEcommerce && !account.merchant_id) || !account.plan_id ) {
    //     if (isEcommerce) limitPlugins.push('Affiliation')
    //     limitPlugins.push('Billing')
    //   }

    //   if (limitPlugins.length) limitPlugins.push('Widget')
    // }

    return state.plugins.filter(p => ( Boolean(p.menu_name) && Boolean(p.icon) && Boolean(p.resource_name) ) )
                        .filter(p => ability.can('read', p.resource_name))
                        .sort((a, b) => {
                          return a.number - b.number
                        })
                        .filter(p => limitPlugins.length ? limitPlugins.includes(p.name) : true)
  }
}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`admin/${params.admin_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      commit('setOrganization', res.data)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async billing ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/billing`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        // default extra keys
        if (res.data.resource) {
          res.data.resource.should_renew = true
          res.data.resource.expire_date_string = ''
        }

        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo suscripciones de la ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo suscripciones de la ${resource_name}.`})
      console.error(e)
    }
  },
  async admins ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/admins_created`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        res.data.resource = res.data.resource.map(a => {
          return {
            admin_id: a.admin_id,
            first_name: a.first_name,
            last_name: a.last_name,
            email: a.email,
            last_login: a.last_login,
            role_id: a.role_id,
            image: a.image,
            can_attend_cases: a.can_attend_cases
          }
        })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo administradores de la ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo administradores de la ${resource_name}.`})
      console.error(e)
    }
  },
  async getPlugins ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/plugins`, {params: params.params || {}})
      commit('setPlugins', res.data)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo plugins de la ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo plugins de la ${resource_name}.`})
      console.error(e)
    }
  },
  async accounts ({ commit }, params) {
    try {
      commit('setAccounts', [])
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/accounts`, {params: params.params || {}})
      if(res.data.success) {
        commit('setAccounts', res.data)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo cuentas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo cuentas de ${resource_name}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  setOrganization (state, data) {
    if (data.success) {
      state.organization = data.resource
    } else {
      state.organization = {}
    }
  },
  setPlugins (state, data) {
    if (data.success) {
      state.plugins = data.resource
    } else {
      state.plugins = []
    }
  },
  setAccounts (state, data) {
    if (data.success) {
      state.accounts = data.resource
    } else {
      state.accounts = []
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
